import { reduxForm, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';

import PurchaseReturnForm from '../../components/Purchase/purchaseReturnForm';
import { fetchVendors, fetchVendorDetail, resetCurrentVendor, fetchVendorInventoryDetail, getVendorBatches, fetchActiveVendors } from '../../actions/vendors_actions';
import { fetchProductsByVendor, fetchProductInfo } from '../../actions/products_actions';
import { fetchPaymentTerms } from '../../actions/paymentTerms_actions';
import { fetchWarehouses } from '../../actions/warehouses_actions';
import { fetchTaxRates } from '../../actions/sales_actions';
import { editPurchaseReturn, createPurchaseReturn, completePurchaseReturn, fetchPurchaseReturnDetail, changeFormValue } from '../../actions/purchaseReturns_actions';
import { setDefaultOfForm, setAllProducts, setPriceValues, resetAllProducts } from '../../actions/purchaseOrders_actions';
import { fetchReturnBatch } from '../../actions/inventories_actions';
import { printPurchaseReturn } from '../../actions/print_actions';
import { isCPG, isVIP } from '../../actions/root_url';
import { fetchBaseUsers } from '../../actions/settings_actions';


const isNumeric = function (n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
};

const validate = (values) => {
  const errors = {};

  if (values.AllProd_Quantity && !isNumeric(values.AllProd_Quantity)) {
      errors.AllProd_Quantity = 'Accept number only!';
  }

  if (values.AllProd_Quantity && (values.AllProd_Quantity < 0)) {
      errors.AllProd_Quantity = 'Positive number only!';
  }

  if (values.AllProd_FOBUnitPrice && !isNumeric(values.AllProd_FOBUnitPrice)) {
      errors.AllProd_FOBUnitPrice = 'Accept number only!';
  }

  if (values.AllProd_FOBUnitPrice && (values.AllProd_FOBUnitPrice < 0)) {
      errors.AllProd_FOBUnitPrice = 'Positive number only!';
  }

  if (values.ShippingCost && !isNumeric(values.ShippingCost)) {
      errors.ShippingCost = 'Accept number only!';
  }

  if (values.ShippingCost && (values.ShippingCost < 0)) {
      errors.ShippingCost = 'Positive number only!';
  }

  if (values.HandlingCost && !isNumeric(values.HandlingCost)) {
      errors.HandlingCost = 'Accept number only!';
  }

  if (values.HandlingCost && (values.HandlingCost < 0)) {
      errors.HandlingCost = 'Positive number only!';
  }

  if (values.Adjustment && !isNumeric(values.Adjustment)) {
      errors.Adjustment = 'Accept number only!';
  }

  if (values.MiscCost && !isNumeric(values.MiscCost)) {
      errors.MiscCost = 'Accept number only!';
  }

  if (values.MiscCost && (values.MiscCost < 0)) {
      errors.MiscCost = 'Positive number only!';
  }

  if (values.Discount && !isNumeric(values.Discount)) {
      errors.Discount = 'Accept number only!';
  }

  if (values.Discount && (values.Discount < 0)) {
      errors.Discount = 'Positive number only!';
  }

  if (!values.ShippingMethod) {
      errors.ShippingMethod = 'Required';
  }

  if (!values.Vendor_id) {
      errors.Vendor_id = 'Required';
  }

  if (!values.Pickup_Warehouse_id) {
    errors.Pickup_Warehouse_id = 'Required';
  }

  if (!values.ReturnReason) {
    errors.ReturnReason = 'Required';
  }
  
  if ((isCPG || isVIP) && !values.MemoNum) {
    errors.MemoNum = 'Required';
  }

  return errors;
};

const purchaseReturnForm = reduxForm({
    form: 'purchaseReturnForm',
    validate,
})(PurchaseReturnForm);

const selector = formValueSelector('purchaseReturnForm');

function mapStateToProps(state) {
    // const productInformation = selector(state, 'ProductInformation');
    const allProducts = selector(state, 'AllProducts');
    const searchType = selector(state, 'SearchType');
    const vendorsValue = selector(state, 'Vendor_id');
    const vendorContactValue = selector(state, 'VendorContact');
    const priceTypeValue = selector(state, 'ConvertItemPrice');
    const miscCostValue = selector(state, 'MiscCost');
    const handlingCostValue = selector(state, 'HandlingCost');
    const adjustmentCostValue = selector(state, 'Adjustment');
    const shippingCostValue = selector(state, 'ShippingCost');
    const allProd_Quantity = selector(state, 'AllProd_Quantity');
    const allProd_FOBUnitPrice = selector(state, 'AllProd_FOBUnitPrice');
    const taxRate = selector(state, 'TaxRate');
    const crv = selector(state, 'CRV');
    const discount = selector(state, 'Discount');
    
    return {
        // productInformation,
        allProducts,
        searchType,
        vendorsValue,
        vendorContactValue,
        priceTypeValue,
        miscCostValue,
        shippingCostValue,
        handlingCostValue,
        adjustmentCostValue,
        allProd_Quantity,
        allProd_FOBUnitPrice,
        taxRate,
        crv,
        discount,

        currentPurchaseReturnDetail: state.purchaseReturns.currentPurchaseReturnDetail,
        currentPurchaseReturn: state.purchaseReturns.currentPurchaseReturn,
        detailIsLoading: state.purchaseReturns.detailIsLoading,
        detailError: state.purchaseReturns.detailError,
        initialValues: state.purchaseReturns.currentPurchaseReturnDetail,

        isEditing: state.purchaseReturns.purchaseReturnIsEditing,
        editError: state.purchaseReturns.purchaseReturnEditError,
        isCreating: state.purchaseReturns.purchaseReturnIsCreating,
        createError: state.purchaseReturns.purchaseReturnCreateError,
        created: state.purchaseReturns.purchaseReturnCreated,
        edited: state.purchaseReturns.purchaseReturnEdited,
        products: state.vendors.currentVendorInventoryDetail,
        vendors: state.vendors.all,
        vendorIsLoading: state.vendors.isLoading,
        vendorError: state.vendors.error,
        currentVendorDetail: state.vendors.currentVendorDetail,
        vendorDetailIsLoading: state.vendors.detailIsLoading,
        vendorDetailError: state.vendors.detailError,
        paymentTerms: state.paymentTerms.all,
        paymentTermsIsLoading: state.paymentTerms.isLoading,
        paymentTermsError: state.paymentTerms.error,
        warehouses: state.warehouses.all,
        warehouseIsLoading: state.warehouses.isLoading,
        warehouseError: state.warehouses.error,
        userPermissions: state.auth.userPermissions,

        simplifiedProducts: state.products.simplifiedProducts,
        simplifiedProductsIsLoading: state.products.simplifiedProductsIsLoading,
        simplifiedProductsError: state.products.simplifiedProductsError,

        taxRates: state.salesOrders.taxRates,
        taxRatesIsLoading: state.salesOrders.taxRatesIsLoading,
        taxRatesError: state.salesOrders.taxRatesError,

        requestingPurchaseReturnPdf: state.print.requestingPurchaseReturnPdf,
        purchaseReturnPdf: state.print.purchaseReturnPdf,
        selectedWarehouse: state.header.selectedWarehouse,
        selectedCompany: state.header.selectedCompany,
        userOptions: (state.settings.all || []).map(user => ({value: user.BaseUser_id, label: user.FirstName})),
    }
}

export default connect(mapStateToProps, {
    editPurchaseReturn, createPurchaseReturn, completePurchaseReturn, setPriceValues, setAllProducts, fetchTaxRates,
    fetchVendors, fetchProductsByVendor, fetchProductInfo, fetchPaymentTerms, setDefaultOfForm, resetAllProducts,
    fetchVendorDetail, resetCurrentVendor, fetchVendorInventoryDetail, fetchPurchaseReturnDetail, getVendorBatches,
    fetchWarehouses, fetchReturnBatch, printPurchaseReturn, fetchActiveVendors,changeFormValue, fetchBaseUsers,
})(purchaseReturnForm)



// WEBPACK FOOTER //
// ./master/jsx/containers/Purchase/purchaseReturnForm.jsx